import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild, ViewEncapsulation} from '@angular/core';
import {BasePlacement} from "@popperjs/core/lib/enums";

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush

})
export class TooltipComponent implements AfterViewInit {
  @Input() wide: boolean = true;
  @Input() autoShow: boolean;
  @Input() autoOpenDelay: number;
  @Input() placement?: BasePlacement;
  @Input() disabled: boolean;
  @Input() keepOpen: boolean;
  @Input() customClass: string = "";
  @Input() manual: boolean;

  @ViewChild("trigger") trigger: ElementRef;
  @ViewChild("tooltipContent") tooltipContent: ElementRef;


  private tooltipElement: JQuery<any>;

  ngAfterViewInit(): void {
    if (this.autoShow) {
      setTimeout(() => this.open(), this.autoOpenDelay || 0);
    }
  }

  open() {
    if (this.disabled) {
      return;
    }
    this.tooltipElement = $(this.trigger.nativeElement).tooltip({
      trigger: "manual",
      title: this.tooltipContent.nativeElement,
      html: true,
      sanitize: true,
      placement: this.placement || "bottom",
      customClass: this.customClass
    });
    this.tooltipElement.tooltip("show");
  }

  toggle() {
    if (this.disabled) {
      return;
    }
    if (!this.tooltipElement) {
      this.open();
    } else {
      this.tooltipElement?.tooltip("toggle");
    }
  }

  close() {
    this.tooltipElement?.tooltip("hide");
  }
}
